import { render } from "./VideoDetails.pug?vue&type=template&id=a1b6be5a&lang=pug"
import script from "./VideoDetails.js?vue&type=script&lang=js"
export * from "./VideoDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__